"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDto = void 0;
class AddressDto {
    constructor(args) {
        if (args) {
            this.firstName = args.firstName;
            this.lastName = args.lastName;
            this.street = args.street;
            this.streetNumber = args.streetNumber;
            this.city = args.city;
            this.country = args.country;
            this.zipCode = args.zipCode;
            this.state = args.state;
            this.addressLine1 = args.addressLine1;
            this.isDefault = args.isDefault;
        }
    }
}
exports.AddressDto = AddressDto;
